module.exports = "pegasus_template/assets/blocks/column-1-theme4.png";